var alignment_rtlignore_default = {
  "alignLeft": "K-mX6",
  "textWrapNowrap": "_37D-X",
  "alignRight": "_4PcWK",
  "alignCenter": "Qy-Ms",
  "sizeFullWidth": "QXEF8",
  "renderedInTable": "askkD",
  "sizeOriginal": "qqtAB",
  "sizeContent": "_0IB7Q",
  "sizeSmall": "UVZ99",
  "sizeSmallCenter": "_3T2W5",
  "flex": "NTnrV",
  "LEFT": "gaH2j",
  "CENTER": "LEG-P",
  "RIGHT": "srSyu",
  "AUTO": "joYDm",
  "JUSTIFY": "_6Vwzd"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
